// extracted by mini-css-extract-plugin
export default {"modal":"SidebarModal_modal__nbF3f","closeButton":"SidebarModal_closeButton__HgdFm","content":"SidebarModal_content__XU8XQ","logoutButton":"SidebarModal_logoutButton__rhLlA"};